export default __webpack_public_path__ + "static/media/hero.c37f758d.jpg";